import styled, { css } from 'styled-components';

import { device } from '@/styles/helpers';

interface ScSliderContainerProps {
  isLobbyRegistrationBannerABTest: boolean;
  registrationBannerUrl: string;
}

export const ScSliderContainer = styled.div<ScSliderContainerProps>`
  width: 100%;
  margin-bottom: -40px;
  overflow: hidden;
  position: relative;
  transition: height 0.3s ease-out;

  ${({ isLobbyRegistrationBannerABTest, registrationBannerUrl }) =>
    isLobbyRegistrationBannerABTest &&
    registrationBannerUrl &&
    css`
      @media (${device.mobile}) {
        height: 630px;
        background: url(${registrationBannerUrl});
        background-size: cover;
        background-position: center;
        background-repeat: no-repeat;
      }
    `};

  .swiper-slide {
    height: auto;
  }

  .swiperArrow {
    margin-top: 0px;
    transform: translate(0, -50%);
    z-index: 5;
    position: absolute;
    left: 32px;
    right: auto;

    &:last-child {
      left: auto;
      right: 32px;
    }
  }
`;
